module.exports = __webpack_public_path__ + "static/media/logo-shared.a83a9df4.png";